<template>
  <div class="w-full mt-4 text-xs">
    <div class="flex font-bold py-px">
      <span class="w-5-5/10 text-xs text-left pl-7">Habit</span>
      <span class="w-3-5/10 text-xs text-left">Category</span>
      <span class="w-1/10"></span>
    </div>

    <draggable
      v-model="habitsOrder"
      ghost-class="ghost"
      @start="drag = true"
      @end="drag = false"
      :move="onMove"
    >
      <div class="flex habit-row" v-for="(habit, i) in habitsOrder" :key="i">
        <span class="w-5-5/10 td-spacing-l cursor-pointer flex items-center">
          <i class="material-icons text-base text-primary">drag_indicator</i>
          <span
            class="ml-1 w-full"
            @touchstart.prevent="goToMonthView(habit)"
            @click="goToMonthView(habit)"
            >{{ habit.name }}</span
          >
        </span>
        <span class="w-3-5/10 td-spacing-c">{{ habit.category }}</span>
        <span
          class="w-1/10 text-primary text-right td-spacing-r cursor-pointer"
          @touchstart.prevent="editHabit(habit)"
          @click="editHabit(habit)"
          >Edit</span
        >
      </div>
    </draggable>
  </div>
</template>

<script>
import habitModule from '@/store/modules/habit.module'
import trackerModule from '@/store/modules/tracker.module'
import categoryModule from '@/store/modules/category.module'
import draggable from 'vuedraggable'

export default {
  name: 'HabitsTable',
  components: { draggable },
  props: ['habits'],

  watch: {
    selectedCategory(newCategory, oldCategory) {
      if (this.orderChanged) {
        this.updateHabitsOrder(oldCategory)
        this.orderChanged = false
      }

      this.habitsOrder = this.habits
    }
  },

  data() {
    return {
      habitsOrder: [],
      orderChanged: false
    }
  },

  computed: {
    selectedHabit: habitModule.selectedHabit,
    monthView: trackerModule.monthView,
    selectedCategory: categoryModule.selectedCategory
  },

  methods: {
    editHabit(habit) {
      this.$router.push({ name: 'EditHabit', params: { habit } })
    },

    goToMonthView(habit) {
      this.selectedHabit = habit
      this.selectedCategory = habit.category
      this.monthView = true
      this.$store.commit('SET_CURRENT_TAB', 'tab2')
      this.$router.push({ name: 'tracker' })
    },

    onMove() {
      this.orderChanged = true
    },

    updateHabitsOrder(category) {
      habitModule.setHabitsOrder(this.habitsOrder, category)
    }
  },

  mounted() {
    this.habitsOrder = this.habits
  },

  beforeDestroy() {
    if (!this.orderChanged) return

    this.updateHabitsOrder(this.selectedCategory)
  }
}
</script>

<style lang="scss" scoped>
.td-spacing-l {
  padding: 6px 0px 6px 8px;
}
.td-spacing-c {
  padding: 6px 0px;
}
.td-spacing-r {
  padding: 6px 10px 6px 0px;
}
.habit-row:nth-of-type(odd) {
  background: #f9f9f9;
}
.pl-7 {
  padding-left: 1.75rem;
}
.w-3-5\/10 {
  width: 35%;
}
.w-5-5\/10 {
  width: 55%;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
